import { Injectable } from '@angular/core';
import { McticHttpClient, McticHttpParams } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { PosicaoNcm } from '../shared/model/posicao-ncm.model';

@Injectable({
  providedIn: 'root'
})
export class PosicaoNcmService {

  private readonly service = '/sepin-backend/rest/posicoes-ncm';

  constructor(private readonly httpClient: McticHttpClient) {
  }

  obterPorNumero(idPleito, numero: number): Observable<string[]> {
    const params = new McticHttpParams();
    if (idPleito) {
      params.set('idPleito', idPleito);
    }
    return this.httpClient.get<string[]>(`${this.service}/autocomplete/${numero}`, {params: params.toHttpParams()});
  }

  obterPosicoesNcm(): Observable<PosicaoNcm[]> {
    return this.httpClient.get<PosicaoNcm[]>(this.service);
  }
}
